module.exports = __webpack_public_path__ + "static/media/pic05.483310dd.jpg";